<template>
  <div>
    <div class="mt-10 flex flex-col justify-center items-center">
      <div v-if="detail?.status == 2" class="">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:svgjs="http://svgjs.com/svgjs"
          width="150"
          x="0"
          y="0"
          viewBox="0 0 367.805 367.805"
          style="margin: 0 auto; display: block"
          xml:space="preserve"
          class=""
        >
          <g>
            <path
              d="M183.903.001c101.566 0 183.902 82.336 183.902 183.902s-82.336 183.902-183.902 183.902S.001 285.469.001 183.903C-.288 82.625 81.579.29 182.856.001h1.047z"
              class="fill-green-500"
            ></path>
            <path
              d="M285.78 133.225 155.168 263.837l-73.143-72.62 29.78-29.257 43.363 42.841 100.833-100.833z"
              fill="#ffffff"
              data-original="#d4e1f4"
              class=""
            ></path>
          </g>
        </svg>
      </div>
      <div class="mt-10">
        <p v-if="detail?.status == 2" class="mt-3 text-center font-medium text-lg">
          {{ $t('page.paymentText', { service: purchase?.service?.name }) }}
        </p>
        <p class="font-medium text-center text-lg">
          {{ $t('page.status') }}: {{ statusMap[$i18n.locale][detail?.status] }}
        </p>
        <p class="font-medium text-center text-lg">
          {{ $t('page.totalPrice') }}: {{ purchase?.total_price }} TMT
        </p>
        <p class="font-medium text-center text-lg">
          {{ $t('page.date') }}: {{ detail?.date_deposited }}
        </p>
      </div>

      <router-link to="/" class="mt-5 bg-main-color text-white px-12 py-2 rounded font-medium">{{
        $t('nav.home')
      }}</router-link>
    </div>
  </div>
</template>

<script>
import api from '@/api';
export default {
  name: 'PaymentStatus',
  components: {},
  data() {
    return {
      loading: false,
      detail: {},
      purchase: {},
      statusMap: {
        tk: {
          0: 'Elýeterli däl',
          1: 'Garaşylýar',
          2: 'Üstünlikli',
          4: 'Gaýtaryldy',
          5: 'Ýatyryldy',
          6: 'Ýalňyşlyk',
        },
        ru: {
          0: 'Недоступно',
          1: 'Зарегистрировано',
          2: 'Успешно',
          4: 'Возврат',
          5: 'Отменено',
          6: 'Ошибка',
        },
      },
    };
  },
  methods: {
    async getPaymentDetail() {
      this.loading = true;
      try {
        const response = await api.get(`payments/payments/${this.$route.params.uuid}/`);
        this.detail = response.data;
        this.purchase = response.data?.purchases?.[0] || {};
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
  created() {
    this.getPaymentDetail();
  },
};
</script>

<!-- <script setup>
const route = useRoute()
const router = useRouter()
const localepath = useLocalePath()
const orderId = ref(route.query.order_id || null)
const order = ref({
    number: '-'
})
const getOrder = async() => {
    const { data } = await useFetchApi({ url: `orders/${orderId.value}` })
    if (data.value?.is_successful === true){
        order.value = data.value?.data
    }
    
}
const goToInvoice = async (uuid) => {

    router.push(localepath(`/invoice?order=${uuid}`))
}

if (orderId.value !== null){
    await getOrder()
}


</script> -->
